import ContextMenu from "src/components/ContextMenu/ContextMenu";

import type { CustomCellRendererProps } from 'ag-grid-react';

import styles from "./BannedUsersModal.module.scss";

interface IBan {
  _id: string;
  club_id: string;
  user_id: string;
  reason: string;
  notes?: string;
  banned_by: string;
  banned_at: string;
  expires_at?: string;
  user: {
    _id: string;
    first_name?: string;
    last_name?: string;
    display_name: string;
    email: string;
  };
  banned_by_user?: {
    _id: string;
    display_name: string;
  };
}

interface IBanRow {
  _id: string;
  user_id: string;
  name: string;
  email: string;
  reason: string;
  banned_at: string;
  ban: IBan;
}

interface CustomBanCellRendererProps extends CustomCellRendererProps<IBanRow> {
  onRemove?: (ban: IBan) => void;
}

export const ActionsRenderer = (props: CustomBanCellRendererProps) => {
  const handleRemove = () => {
    if (props.onRemove && props.data) {
      props.onRemove(props.data.ban);
    }
  };

  return (
    <div className={styles.ActionRenderer}>
      <ContextMenu
        options={[
          { 
            label: "Remove",
            onClick: handleRemove
          }
        ]}
      />
    </div>
  );
};

